<template>
  <table class="table-to-export" data-sheet-name="注文書">
    <tbody>
    <tr><td></td><td></td><td></td><td>発行</td><td>{{now}}</td></tr>
    <tr><td></td><td></td><td>注文書</td><td></td><td></td></tr>
    <tr><td></td><td></td><td></td><td></td><td></td></tr>
    <tr><td>〒{{operatorOffice.postcode}}</td><td></td><td></td><td></td><td>〒{{clientOffice.postcode}}</td></tr>
    <tr><td>{{operatorOffice.address}}</td><td></td><td></td><td></td><td>{{clientOffice.address}}</td></tr>
    <tr><td>{{operatorOffice.name}}</td><td></td><td></td><td></td><td>{{clientOffice.name}}</td></tr>
    <tr><td>{{operatorDetail.lastName}} {{operatorDetail.firstName}}</td><td>様</td><td></td><td></td><td>{{clientDetail.lastName}} {{clientDetail.firstName}}</td></tr>
    <tr><td></td><td></td><td></td><td></td><td></td></tr>
    <tr><td>件名：</td><td>{{work.title}}</td><td></td><td></td><td>TEL {{clientOffice.phoneNumber}}</td></tr>
    <tr><td></td><td></td><td></td><td></td><td>MAIL {{clientDetail.email}}</td></tr>
    <tr><td>以下の通り注文いたします。</td><td></td><td></td><td></td><td></td><td></td></tr>
    <tr><td>合計金額（税込）</td><td>{{separatedRewardsWithTax}}</td><td></td><td></td><td></td><td></td></tr>
    <tr><td></td><td></td><td></td><td></td><td></td></tr>
    <tr><td>内訳</td><td>数量</td><td>単価</td><td>金額</td><td>備考</td></tr>
    <tr><td>作図作業</td><td>1式</td><td>¥{{separatedRewardsWithoutTax}}</td><td>¥{{separatedRewardsWithoutTax}}</td><td></td></tr>
    <tr><td>消費税（{{FEES.TAX}}％）</td><td></td><td></td><td>¥{{separatedTax}}</td><td></td></tr>
    <tr><td></td><td></td><td></td><td></td><td></td></tr>
    <tr><td>契約条件 ※注意！下記に示す契約条件は一例です。クライアントとオペレーターの間で打ち合わせを行った結果を踏まえて適宜修正ください。</td><td></td><td></td><td></td><td></td></tr>
    <tr><td>納期：</td><td>{{deadline}}</td><td></td><td></td><td></td></tr>
    <tr><td>納品方法：</td><td>flewが提供するファイル送受信フォームを使用すること。</td><td></td><td></td><td></td></tr>
    <tr><td>支払い条件：</td><td>契約後に発注者がflewの決済システムを利用して仮払いを行い、検収後に受注者のアカウントに送金される。</td><td></td><td></td><td></td></tr>
    <tr><td>納品後、発注者は納期から72時間以内に成果品の検査を行い、その結果を受注者に通知する。仮に72時間を過ぎて通知が無い場合は検査合格とする。</td><td></td><td></td><td></td><td></td></tr>
    <tr><td>検査の結果不合格となった場合、発注者は速やかに修正指示を出し、受注者はそれに応えて修正・再納品を行うこととする。</td><td></td><td></td><td></td><td></td></tr>
    <tr><td>納期から一週間を過ぎて修正が完了せず検収できない場合、仮払い金は一旦発注者のもとに返金する。その後受注者の作業の出来高に応じた支払いを行い業務終了とする。</td><td></td><td></td><td></td><td></td></tr>
    <tr><td>受注者は発注者から受領した資料および資料に含まれる情報（意匠、技術、建物や製品の固有の情報）を第三者に漏洩させたり、他案件で流用しては</td><td></td><td></td><td></td><td></td></tr>
    <tr><td>ならない。万が一受注者の責めに帰すべき理由により漏洩させたり、理由の如何に関わらず流用した場合には、それにより発注者が被る損害を補償</td><td></td><td></td><td></td><td></td></tr>
    <tr><td>する義務を負う。</td><td></td><td></td><td></td><td></td></tr>
    </tbody>
  </table>
</template>

<script>
  import moment from "moment";
  import FEES from "@/assets/js/constants/fees";

  export default {
    name: "OrderBlock",

    props: {
      clientDetail: {
        type: Object,
        required: true
      },
      operatorDetail: {
        type: Object,
        required: true
      },
      clientOffice: {
        type: Object,
        required: true
      },
      operatorOffice: {
        type: Object,
        required: true
      },
      work: {
        type: Object,
        required: true
      },
    },

    computed: {
      now() {
        return moment().format('LL');
      },
      rewardsWithTax() {
        return this.work.rewards ? this.work.rewards : 0;
      },
      rewardsWithoutTax() {
        return Math.ceil(this.work.rewards / (1 + FEES.TAX * 0.01))
      },
      tax() {
        return this.work.rewards ? this.work.rewards - this.rewardsWithoutTax : 0;
      },
      separatedRewardsWithTax() {
        return this.rewardsWithTax.toLocaleString();
      },
      separatedRewardsWithoutTax() {
        return this.rewardsWithoutTax.toLocaleString();
      },
      separatedTax() {
        return this.tax.toLocaleString();
      },
      deadline() {
        return !this.work.deadline ? '' : moment.unix(this.work.deadline.seconds).format('YYYY/MM/DD HH:mm');
      },
    },
    beforeCreate() {
      Object.assign(this, {FEES});
    },

  }
</script>

<style scoped>

</style>